import * as Types from '../constants/actionTypes';

export default (state = {entitiesList: []}, action) => {
    switch (action.type) {
        case Types.ENTITY_DETAIL_SUCCESS:
            return Object.assign({}, state, { entitiesList: action.payload || [], isPanding: false })
        case Types.ENTITY_ADDED_SUCCESS:
            state.entitiesList.push(action.payload)
            return {
                ...state
            }
        case Types.ENTITY_DELETED_SUCCESS:
            state.entitiesList.splice(action.deleteIndex,1)
            return {
                ...state
            }
        case Types.ENTITY_UPDATE_SUCCESS:
            state.entitiesList[action.updateIndex] = action.payload
            return {
                ...state
            }
        case Types.ENTITY_ERROR:
           return {
                entityError: action.entityError
            }
        case Types.ENTITY_UPLOAD_ERROR:
            return {
                entityUploadError:action.error
            }
        case Types.ENTITY_LIST_COUNT_SUCCESS:
            return {
                entityListCount: action.payload
            }
        case Types.ENTITY_UPLOAD_SUCCESS:
            return {
                uploadSuccessmessage: action.payload
            }
        case Types.ENTITY_DETAIL_BY_COUNTRY_ID_SUCCESS:
                return {
                    entityListByCountryId: action.payload
                }
        case Types.ENTITY_INFO_BY_ENTITY_ID_SUCCESS:
                return {
                    entityInfoByEntityId: action.payload
                }
                
        default:
            return state
    }
}
